import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getAllSegments = () => {
    return axios.get(`/api/segment/list`, { headers: authHeaderJson() } );
};

const getAllCategories = () => {
    return axios.get(`/api/segment/list/category`, { headers: authHeaderJson() } );
};


export {
    getAllSegments,
    getAllCategories
}